<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomButton from "../../CustomButton/index.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import PoliticInfo from "./PoliticInfo.vue";
import FinancialInfo from "./FinancialInfo.vue";
import CustomSelect from "../../global/CustomSelect/index.vue";
import EmploymentInfo from "./EmploymentInfo.vue";
import useVuelidate from "@vuelidate/core";
import {required, requiredIf} from "@vuelidate/validators";
import {createUser} from "../../../api/user";
import WarningInfo from "../../WarningInfo.vue";

export default {
  name: "Employment",
  components: {
    WarningInfo,
    EmploymentInfo,
    CustomSelect,
    FinancialInfo,
    PoliticInfo,
    CustomTextDropdown,
    CustomTextField,
    CustomCheckbox,CommonSubtitle},
  setup() {
    const v$ = useVuelidate();
    return {v$};
  },
  data() {
    return {
      loading: false,
      formData: {
        employmentInfo: {
          unemployed: false,
          education_level: '',
          profession: '',
          employment_status: '',
          employer_segment: '',
          employer_name: '',
          position: '',
          employer_address: '',
          employer_phone: '',
          education_level_text: '',
          employment_status_text: ''
        },
        financialInfo: {
          source_of_income: null,
          source_of_income_text: '',
          salary: null,
          trading_amount: null
        },
        politicInfo: {
          is_pep: false,
          pep_firstname: '',
          pep_lastname: '',
          pep_position: '',
          pep_relative: '',
          pep_notes: ''
        }
      }
    }
  },
  validations() {
    const isEmployed = () => !(this.formData.employmentInfo.employment_status === '8' || this.formData.employmentInfo.employment_status === '10')
    // const unEmployed = () => this.formData.employmentInfo.employment_status == 8
    const isPep = () => this.formData.politicInfo.is_pep && !this.formData.politicInfo.pep_notes
    const educationLevelIsOther = () => this.formData.employmentInfo.education_level == 0
    const employmentStatusIsOther = () => this.formData.employmentInfo.employment_status == 11
    const sourceOfIncomeHasOther = () => this.formData.financialInfo.source_of_income.split(';').includes('0')
    return {
      formData: {
        employmentInfo: {
          education_level: {required},
          profession: {required},
          employment_status: {required},
          employer_segment: {required: requiredIf(isEmployed)},
          employer_name: {required: requiredIf(isEmployed)},
          position: {required: requiredIf(isEmployed)},
          employer_address: {required: requiredIf(isEmployed)},
          employer_phone: {required: requiredIf(isEmployed)},
          education_level_text: {required: requiredIf(educationLevelIsOther)},
          employment_status_text: {required: requiredIf(employmentStatusIsOther)}
        },
        financialInfo: {
          source_of_income: {required},
          source_of_income_text: {required: requiredIf(sourceOfIncomeHasOther)},
          salary: {required},
          trading_amount: {required}
        },
        politicInfo: {
          is_pep: {required},
          pep_firstname: {required: requiredIf(isPep)},
          pep_lastname: {required: requiredIf(isPep)},
          pep_position: {required: requiredIf(isPep)},
          pep_relative: {required: requiredIf(isPep)},
        }
      }
    }
  },
  methods: {
    async submitForm() {
      console.log(this.formData.financialInfo)
      this.v$.$touch()
      if (!this.v$.$error) {
        this.loading = true
        console.log("submitting form", this.formData);
        try {
          //prepare PepData
          const pepData = {
            is_pep: this.formData.politicInfo.is_pep,
          }
          if (this.formData.politicInfo.is_pep) {
            pepData.pep_notes = this.formData.politicInfo.pep_notes ?? this.formData.politicInfo.pep_relative + ' - ' + this.formData.politicInfo.pep_lastname + ' ' + this.formData.politicInfo.pep_firstname + ' : ' + this.formData.politicInfo.pep_position
          }
          let employmentData = {...this.formData.employmentInfo}
          if(this.formData.employmentInfo.employment_status === '8') {
            employmentData['employer_name'] = null
            employmentData['position'] = null
            employmentData['employer_address'] = null
            employmentData['employer_phone'] = null
            employmentData['employer_segment'] = null
          }

          await Promise.all([
            createUser('employment-status', employmentData),
            createUser('financial', this.formData.financialInfo),
            createUser('monpep', pepData),
          ])
          this.loading = false
          this.$bvToast.toast(
              'Амжилттай мэдээлэл хадгаллаа',
              {title: 'Амжилттай', variant: 'success'},
          )
          this.$emit('selectTab', 3)
          await this.$store.dispatch('user/fetchUser')
        } catch (e) {
          console.log(e)
        }
      } else {
        this.loading = false
        console.log("has errors: ", this.v$.$errors)
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="ml-4 mr-4 mt-4 mb-4">
      <warning-info :body="$t('warning_info.warn1')"/>
    </div>
    <EmploymentInfo class="mb-4" :employment-info="formData.employmentInfo" :v$="v$.formData.employmentInfo"/>
    <FinancialInfo class="mb-4" :financial-info="formData.financialInfo" :v$="v$.formData.financialInfo"/>
    <PoliticInfo class="mb-4" :politic-info="formData.politicInfo" :v$="v$.formData.politicInfo"/>
    <div class="d-flex justify-content-center mt-xl-5">
      <ic-button class="card-button" size="tn" :loading="loading" @click="submitForm">Хадгалах</ic-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .st-kyc-alert {
    justify-content: left;
    align-items: flex-start;
    display: flex;
    background-color: var(--warning-color-10);
    border: 1px solid var(--warning-color);
    border-radius: 5px;
    padding: 15px;
    i {
      color: var(--warning-color);
    }
  }
  .st-kyc-alert-body {
    flex: 1;
    margin-left: 10px;
    h5 {
      font-weight: 700;
      font-size: 12px;
      color: var(--primary-color-new);
      margin-bottom: 5px;
    }
    p {
      margin-top: 0;
      font-weight: 400;
      font-size: 11px;
      line-height: 13px;
      color: var(--primary-color-new);
    }
  }
</style>